export const paletteBlue = {
  primary: {
    lighter: '#E3F2FD',
    light: '#64B5F6',
    main: '#1976D2', // Blue 700 - Primary
    dark: '#1565C0',
    darker: '#0D47A1', 
    contrastText: '#ffffff',
  },
  secondary: {
    lighter: '#F3E5F5',
    light: '#BA68C8',
    main: '#9C27B0', // Purple for secondary actions
    dark: '#7B1FA2',
    contrastText: '#ffffff',
  },
  error: {
    light: '#EF5350',
    main: '#D32F2F',
    dark: '#C62828',
    contrastText: '#fff',
  },
  warning: {
    light: '#FFF9C4',
    main: '#FBC02D',
    dark: '#F57F17',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  success: {
    light: '#C8E6C9',
    main: '#2E7D32',
    dark: '#1B5E20',
    contrastText: '#fff',
  },
  info: {
    main: '#0288D1', 
    light: '#03A9F4', 
    dark: '#01579B', 
    contrastText: '#fff'
  },
  background: {
    default: '#F4F6F8', // Neutral grey tint
    paper: '#FFFFFF',
    neutral: '#F3F4F6',
  },
  text: {
    primary: '#1F2937', 
    secondary: '#4B5563', 
    disabled: '#9CA3AF', 
  },
  divider: '#E5E7EB',
  brand: {
    main: '#0D47A1',
    light: '#E3F2FD',
    lighter: '#EDE7F6',
    dark: '#1a237e',
    contrastText: '#ffffff',
    headerBg: '#1976D2',     // = primary.main
    headerText: '#ffffff',
    rowHover: '#E3F2FD',
  },
};
